'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INCLUDE = exports.INCLUDE = 'INCLUDE';
var EXCLUDE = exports.EXCLUDE = 'EXCLUDE';
var ALL_PAGES = exports.ALL_PAGES = 'ALL_PAGES';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/TargetingRuleTypes.js
// module id = 912
// module chunks = 2 3